/* imports */
import _ from 'lib/lodash'
import filesize from 'filesize'

import db from 'db'

/* action types */
export const types = {
	IS_LOADING: 'NODE/IS_LOADING',
	IS_ERROR: 'NODE/IS_ERROR',

	CREATE_FILE_NODE: 'NODE/CREATE_FILE_NODE',
	CREATE_FILE_NODE_SUCCESS: 'NODE/CREATE_FILE_NODE_SUCCESS',
	CREATE_FILE_NODE_ERROR: 'NODE/CREATE_FILE_NODE_ERROR',

	POST_FILE_SUCCESS: 'NODE/POST_FILE_SUCCESS',
	POST_FILE_ERROR: 'NODE/POST_FILE_ERROR',
	POST_FILE_IS_UPLOADING: 'NODE/POST_FILE_IS_UPLOADING',
	POST_FILE_UPDATE: 'NODE/POST_FILE_UPDATE',

	POST_NODE_SUCCESS: 'NODE/POST_NODE_SUCCESS',
	POST_NODE_ERROR: 'NODE/POST_NODE_ERROR',

	DELETE_NODE_IS_DELETING: 'NODE/DELETE_NODE_IS_DELETING',
	DELETE_NODE_SUCCESS: 'NODE/DELETE_NODE_SUCCESS',
	DELETE_NODE_ERROR: 'NODE/DELETE_NODE_ERROR',

	CHANGE_NODE_PROPERTY_IS_CHANGING: 'NODE/CHANGE_NODE_PROPERTY_IS_CHANGING',
	CHANGE_NODE_PROPERTY_SUCCESS: 'NODE/CHANGE_NODE_PROPERTY_SUCCESS',
	CHANGE_NODE_PROPERTY_ERROR: 'NODE/CHANGE_NODE_PROPERTY_ERROR',

	RESET_STATE: 'NODE/RESET_STATE'
};

/* initial state */
export const initialState = {
	isLoading: false,
	error: null,
	node: null,

	currentNode: null,
	newNode: null,
	finalSnapshot: null,

	// upload
	isUploading: false,
	uploadStatus: {
		bytesTransferred: 0,
		totalBytes: 0,
		progress: 0
	},
	// deletion
	isDeleting: false,
	deletionSuccess: false,
	// change
	isChanging: false

};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case types.IS_LOADING:
			return {	...state, isLoading: true	};

		case types.IS_ERROR:
			return {	...state, isLoading: false, error: action.error };

		case types.CREATE_FILE_NODE_SUCCESS:
			return { ...state, isLoading: false, currentNode: action.newNode };

		case types.CREATE_FILE_NODE_ERROR:
			return { ...state, isLoading: false, error: action.error };

		case types.POST_FILE_SUCCESS:
			return {	...state, isLoading: false, error: null, finalSnapshot: action.finalSnapshot, isUploading: false };

		case types.POST_FILE_ERROR:
			return {	...state, isLoading: false, error: action.error, isUploading: false };

		case types.POST_FILE_IS_UPLOADING:
			return {	...state, isLoading: false, error: null, isUploading: true };

		case types.POST_FILE_UPDATE:
			return {	...state, isLoading: false, error: null,
				uploadStatus: {
					bytesTransferred: action.snapshot.bytesTransferred,
					totalBytes: action.snapshot.totalBytes,
					progress: 100 * action.snapshot.bytesTransferred / action.snapshot.totalBytes
				}
			};

		case types.POST_NODE_SUCCESS:
			return {	...state, isLoading: false, error: null, currentNode: action.newNode };

		case types.POST_NODE_ERROR:
			return {	...state, isLoading: false, error: action.error, currentNode: null };

		case types.DELETE_NODE_IS_DELETING:
			return {	...state, isLoading: false, isDeleting: true, currentNode: action.node };

		case types.DELETE_NODE_SUCCESS:
			return {	...state, isLoading: false, isDeleting: false, currentNode: null, error: null, deletionSuccess: true };

		case types.DELETE_NODE_ERROR:
			return {	...state, isLoading: false, isDeleting: false, currentNode: null, error: action.error, deletionSuccess: false };

		case types.CHANGE_NODE_PROPERTY_IS_CHANGING:
			return {	...state, isLoading: false, isChanging: true, error: null };

			case types.CHANGE_NODE_PROPERTY_SUCCESS:
			return {	...state, isLoading: false, isChanging: false, error: null };

		case types.CHANGE_NODE_PROPERTY_ERROR:
			return {	...state, isLoading: false, isChanging: false, error: action.error };

		case types.RESET_STATE:
			return initialState;

		default:
			return state;
	}
}

/* action creators */
export const actions = {
	isLoading: () => ({ type: types.IS_LOADING }),
	raiseError: (error) => ({ type: types.IS_ERROR, error }),

	createFileNodeSuccess: newNode => ({ type: types.CREATE_FILE_NODE_SUCCESS, newNode }),
	createFileNodeError: error => ({ type: types.CREATE_FILE_NODE_ERROR, error }),

	postFileSuccess: finalSnapshot => ({ type: types.POST_FILE_SUCCESS, finalSnapshot }),
	postFileError: error => ({ type: types.POST_FILE_ERROR, error }),
	postFileIsUploading: () => ({ type: types.POST_FILE_IS_UPLOADING }),
	postFileUpdate: snapshot => ({ type: types.POST_FILE_UPDATE, snapshot }),

	postNodeSuccess: newNode => ({ type: types.POST_NODE_SUCCESS, newNode }),
	postNodeError: error => ({ type: types.POST_NODE_ERROR, error }),

	deleteNodeIsDeleting: node => ({ type: types.DELETE_NODE_IS_DELETING, node }),
	deleteNodeSuccess: () => ({ type: types.DELETE_NODE_SUCCESS }),
	deleteNodeError: error => ({ type: types.DELETE_NODE_ERROR, error }),

	changeNodePropertyIsChanging: node => ({ type: types.CHANGE_NODE_PROPERTY_IS_CHANGING, node }),
	changeNodePropertySuccess: () => ({ type: types.CHANGE_NODE_PROPERTY_SUCCESS }),
	changeNodePropertyError: error => ({ type: types.CHANGE_NODE_PROPERTY_ERROR, error }),

	resetState: () => ({ type: types.RESET_STATE }),
};

export const dispatchActions = {
	resetNodeHandler: () => dispatch => dispatch(actions.resetState()),

	createFileNode: (payload, nodeType, file, properties, cb) => {
		const constraintValidationError = () => {
			/* check for valid file type */
			const typeConstraints = _.get(payload, `constraints[${nodeType}]`);

			if (!typeConstraints || !typeConstraints.contentTypes || typeConstraints.contentTypes.length === 0) return null;
			if (!typeConstraints.contentTypes.includes(file.type)) {
				return new Error(`Upload nicht möglich. Erlaubte Formate: ${typeConstraints.contentTypes.join(', ')}`);
			}

			/* check for storage size constraint */
			const maxStorageSize = _.get(payload, 'constraints.maxStorageSize');
			if (!maxStorageSize) return null;

			const payloadStorageSize = _.get(payload, 'statistics.storageSize') || 0;
			const totalSizeAvailable = maxStorageSize - payloadStorageSize;
			if (file.size > totalSizeAvailable) {
				return totalSizeAvailable > 0
					? new Error(`Die Datei ist leider zu groß. Ihnen stehen auf diesem Sticker noch ${filesize(totalSizeAvailable)} zur Verfügung.`)
					: new Error(`Die Datei kann nicht hochgeladen werden, da kein Speicherplatz mehr verfügbar ist.`);
			}
			return null;
		};

		return dispatch => {
			const constraintError = constraintValidationError();
			if (!constraintError) {
				const tempNode = {
					$type: nodeType,
					$path: `${payload.$path}/nodes/${nodeType}`,
					contentType: file.type,
					creationDate: (new Date()).toISOString(),
					properties
				};
				dispatch(actions.createFileNodeSuccess(tempNode));
				dispatch(dispatchActions.postNodeAndFile(payload, tempNode, file, cb));
			} else {
				dispatch(actions.createFileNodeError(constraintError));
			}
		}
	},

	postNode: (payload, nodeType, node, cb) => {
		return dispatch => {
			const tempNode = {
				...node,
				$path: `${payload.$path}/nodes/${nodeType}`,
				creationDate: (new Date()).toISOString(),
			};
			db.postNode(payload, tempNode)
				.then((newNode) => {
					dispatch(actions.postNodeSuccess(newNode));
					cb(newNode);
				})
				.catch(error => dispatch(actions.postNodeError(error)));
		}
	},

	postNodeAndFile: (payload, node, file, cb) => dispatch => {
		const onTick = (snapshot) => dispatch(actions.postFileUpdate(snapshot));
		const onComplete = (finalSnapshot) => dispatch(actions.postFileSuccess(finalSnapshot));
		const onError = (error) => dispatch(actions.postFileError(error));

		dispatch(actions.postFileIsUploading());

		db.postNodeAndFile(payload, node, file, onTick, onComplete, onError)
			.then((newNode) => {
				dispatch(actions.postNodeSuccess(newNode));
				cb(newNode);
			})
			.catch(error => dispatch(actions.postNodeError(error)));
	},

	deleteNode: (node) => dispatch => {
		dispatch(actions.deleteNodeIsDeleting(node));

		return db.deleteNode(node)
			.then(() => dispatch(actions.deleteNodeSuccess()))
			.catch(error => dispatch(actions.deleteNodeError(error)));
	},

	changeNodeProperty: (node, property) => dispatch => {
		dispatch(actions.changeNodePropertyIsChanging(node));

		return db.changeNodeProperty(node, property)
			.then(() => dispatch(actions.changeNodePropertySuccess()))
			.catch(error => dispatch(actions.changeNodePropertyError(error)));
	}
};


// WEBPACK FOOTER //
// ./src/components/node/nodeHandlerRedux.jsx